export default __webpack_public_path__ + "static/media/ideagen-learning-lockup-light.9b48d25d.png";